import React, { useState, useContext, useEffect } from "react";

import SuiAvatar from "components/SuiAvatar";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

const ReadMore = ({ children, limit = 150, ...rest }) => {
  let text = children || "";
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = (e) => {
    e.stopPropagation();
    setIsReadMore(!isReadMore);
  };
  return (
    <SuiTypography variant="text" fontWeight="regular" color="dark" textTransform="none" {...rest}>
      {text.length < limit ? (
        <div>{text}</div>
      ) : (
        <div>
          {isReadMore ? text.slice(0, limit) + "..." : text}
          <SuiButton onClick={toggleReadMore} variant="text" color="info">
            {isReadMore ? "read more" : " show less"}
          </SuiButton>
        </div>
      )}
    </SuiTypography>
  );
};

export default ReadMore;
